import React, { FC } from 'react'
import { Wrapper, Header, Subtitle, ElementTitle, ElementSubtitle } from './styled'

interface ComponentProps {
	title: () => JSX.Element
	subtitle: string
	firstElementTitle: string
	firstElementSubtitle: string
	secondElementTitle: string
	secondElementSubtitle: string
	thirdElementTitle: string
	thirdElementSubtitle: string
}

export const ServicePackagesElementComponent: FC<ComponentProps> = ({
	title,
	subtitle,
	firstElementTitle,
	firstElementSubtitle,
	secondElementTitle,
	secondElementSubtitle,
	thirdElementTitle,
	thirdElementSubtitle,
}) => (
	<Wrapper>
		<Header>
			{title()}
			<Subtitle>{subtitle}</Subtitle>
		</Header>
		<ElementTitle>{firstElementTitle}</ElementTitle>
		<ElementSubtitle>{firstElementSubtitle}</ElementSubtitle>
		<ElementTitle>{secondElementTitle}</ElementTitle>
		<ElementSubtitle>{secondElementSubtitle}</ElementSubtitle>
		<ElementTitle>{thirdElementTitle}</ElementTitle>
		<ElementSubtitle>{thirdElementSubtitle}</ElementSubtitle>
	</Wrapper>
)
